import { useEffect, useState } from 'react';
import {
  addTotalLoanCompositionRow,
  loansCompositionConverter
} from '../utils/masterPoolDetailsUtils';
import { TranslationType } from '../../HbtMasterPoolTable/types';
import { MasterPoolLoanComposition } from '../../HbtMasterPool/types';
import { LoanValidationDetailsType } from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/api/types';

export const useLoanComposition = (
  loanCompositions: MasterPoolLoanComposition[] | undefined,
  t: TranslationType
) => {
  const [loanSummaryError, setLoanSummaryError] = useState<string>('');
  const [showLoanCompositionError, setLoanCompositionError] = useState<boolean>(false);
  const [convertedLoansDetails, setConvertedLoansDetails] = useState<LoanValidationDetailsType[]>(
    []
  );

  useEffect(() => {
    if (!loanCompositions) return;

    const isEmptyOrNull =
      loanCompositions.length === 0 || loanCompositions.every((item) => item === null);

    if (isEmptyOrNull) {
      setLoanSummaryError((prev) =>
        prev !== 'no_data_error_master_pool' ? 'no_data_error_master_pool' : prev
      );
      setLoanCompositionError(true);
      setConvertedLoansDetails([]);
      return;
    }

    const converted = loansCompositionConverter(loanCompositions, t);
    const updatedDetails = addTotalLoanCompositionRow(loanCompositions, converted);
    setConvertedLoansDetails(updatedDetails);
    setLoanCompositionError(false);
  }, [loanCompositions, t]);

  return {
    loanSummaryError,
    showLoanCompositionError,
    convertedLoansDetails
  };
};
